// @see https://github.com/AS3Commons/as3commons-collections/blob/master/src/org/as3commons/collections/Set.as

interface Set<T> {
    add(value: T) : boolean;
    remove(value: T) : boolean;
    toArray(): T[];
}

const originalSetAdd = Set.prototype.add;
Object.assign(Set.prototype, {
  add : function(value: any) {
    originalSetAdd.call(this, value);
    return true;
  },

  remove : Set.prototype.delete,

  toArray : function(this: Set<any>) {
    return Array.from(this.values());
  }
});

